module.exports = __webpack_public_path__ + "img/red_triangle.76b04c2.png";